export const formatCurrency = (value) => {
    if (value == null || isNaN(value)) return '0,00 €';
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value);
};

export const pluralUnit = (unit, qty) => {
    if (!unit) return '';
    if (qty > 1 && (unit === 'portion' || unit === 'pièce')) return unit + 's';
    return unit;
};

/** Extract contenance (weight/volume/pieces) from supplier product name. E.g. "Riz 20kg" → 20, "Vinaigre 18L" → 18, "Barquette x600" → 600 */
export const parseContenanceFromName = (name, baseUnit) => {
    if (!name) return 0;
    const patterns = [
        { regex: /(\d+(?:[.,]\d+)?)\s*kg/i, unit: 'kg', factor: 1 },
        { regex: /(\d+(?:[.,]\d+)?)\s*g(?!a)/i, unit: 'kg', factor: 0.001 },
        { regex: /(\d+(?:[.,]\d+)?)\s*[lL](?:itre)?/i, unit: 'L', factor: 1 },
        { regex: /(\d+(?:[.,]\d+)?)\s*[lL](?:itre)?/i, unit: 'litre', factor: 1 },
        { regex: /(\d+(?:[.,]\d+)?)\s*ml/i, unit: 'L', factor: 0.001 },
        { regex: /(\d+(?:[.,]\d+)?)\s*ml/i, unit: 'litre', factor: 0.001 },
        { regex: /(\d+(?:[.,]\d+)?)\s*cl/i, unit: 'L', factor: 0.01 },
        { regex: /(\d+(?:[.,]\d+)?)\s*cl/i, unit: 'litre', factor: 0.01 },
        { regex: /x\s*(\d+)/i, unit: 'pièce', factor: 1 },
        { regex: /x\s*(\d+)/i, unit: 'piece', factor: 1 },
    ];
    const bu = (baseUnit || '').toLowerCase();
    for (const p of patterns) {
        if (p.unit.toLowerCase() !== bu) continue;
        const match = name.match(p.regex);
        if (match) {
            const val = parseFloat(match[1].replace(',', '.'));
            return Math.round(val * p.factor * 10000) / 10000;
        }
    }
    return 0;
};
